import script from "./FinancialCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancialCenter.vue?vue&type=script&setup=true&lang=js"

import "./FinancialCenter.vue?vue&type=style&index=0&id=2dd9a337&lang=css"

const __exports__ = script;

export default __exports__